(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breakaway-announcement"] && !Shopify.designMode) return;
  try {
    
(function(){
  var bar=document.querySelector('.bk-annc'); if(!bar||bar.__bkInit)return; bar.__bkInit=true;
  var msgs=bar.querySelectorAll('.bk-annc-msg'); if(msgs.length<2)return;
  var i=0, ms=(parseFloat(bar.getAttribute('data-interval'))||4)*1000;
  setInterval(function(){
    msgs[i].classList.remove('is-active');
    i=(i+1)%msgs.length;
    msgs[i].classList.add('is-active');
  }, ms);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakaway-entries"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBke(root){
    if(root.dataset.bkeReady) return; root.dataset.bkeReady="1";
    var els=root.querySelectorAll('.reveal');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.15});
      els.forEach(function(el){io.observe(el);});
    } else { els.forEach(function(el){el.classList.add('in');}); }
  }
  function initAll(){ document.querySelectorAll('[data-bke]').forEach(initBke); }
  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakaway-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHero(root){
    if(root.dataset.bkheroReady) return;
    root.dataset.bkheroReady = "1";

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    var dots   = Array.prototype.slice.call(root.querySelectorAll("[data-dot]"));
    if(slides.length < 2) return;

    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var autoplay = root.dataset.autoplay === "true" && !reduce;
    var speed = (parseFloat(root.dataset.speed) || 6) * 1000;

    function show(n){
      i = (n + slides.length) % slides.length;
      slides.forEach(function(s,idx){ s.classList.toggle("is-active", idx===i); });
      dots.forEach(function(d,idx){ d.classList.toggle("is-active", idx===i); });
    }
    function next(){ show(i+1); }
    function prev(){ show(i-1); }

    function start(){ if(autoplay){ stop(); timer=setInterval(next, speed); } }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }

    var nextBtn = root.querySelector("[data-next]");
    var prevBtn = root.querySelector("[data-prev]");
    if(nextBtn) nextBtn.addEventListener("click", function(){ next(); start(); });
    if(prevBtn) prevBtn.addEventListener("click", function(){ prev(); start(); });
    dots.forEach(function(d){ d.addEventListener("click", function(){ show(parseInt(d.dataset.index,10)); start(); }); });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);

    // swipe on touch
    var x0 = null;
    root.addEventListener("touchstart", function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    root.addEventListener("touchend", function(e){
      if(x0===null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if(Math.abs(dx) > 40){ dx < 0 ? next() : prev(); start(); }
      x0 = null;
    }, {passive:true});

    show(0);
    start();
  }

  function initAll(){ document.querySelectorAll("[data-bkhero]").forEach(initHero); }

  function initCountdowns(){
    document.querySelectorAll("[data-bkhero-cd]").forEach(function(el){
      if(el.dataset.cdReady) return; el.dataset.cdReady = "1";
      var draw = el.getAttribute("data-draw");
      var target = draw ? new Date(draw + "T20:00:00") : null;
      if(!target || isNaN(target)){ var n=new Date(); target=new Date(n.getFullYear(), n.getMonth()+1, 0, 20,0,0); }
      if(target < new Date()){ target.setMonth(target.getMonth()+1); }
      var p = function(n){ return String(n).padStart(2,"0"); };
      function tick(){
        var d = Math.max(0, target - new Date());
        var days=Math.floor(d/864e5); d-=days*864e5;
        var h=Math.floor(d/36e5); d-=h*36e5;
        var m=Math.floor(d/6e4); d-=m*6e4;
        var sec=Math.floor(d/1e3);
        el.querySelector("[data-d]").textContent=p(days);
        el.querySelector("[data-h]").textContent=p(h);
        el.querySelector("[data-m]").textContent=p(m);
        el.querySelector("[data-s]").textContent=p(sec);
      }
      tick(); setInterval(tick,1000);
    });
  }

  function boot(){ initAll(); initCountdowns(); }
  if(document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakaway-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__bkHome)return; window.__bkHome=true;
  var root=document.querySelector('.bk-home'); if(!root)return;

  /* reveal on scroll */
  var els=root.querySelectorAll('.bk-section, .cat, .card, .tier, .rev, .ig, .step');
  els.forEach(function(el){el.classList.add('reveal')});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){io.observe(el)});
  } else { els.forEach(function(el){el.classList.add('in')}); }

  /* giveaway countdown */
  var cd=document.getElementById('bk-countdown');
  if(cd){
    var draw=cd.getAttribute('data-draw'); var target=draw?new Date(draw+'T20:00:00'):null;
    if(!target||isNaN(target)){var n=new Date();target=new Date(n.getFullYear(),n.getMonth()+1,0,20,0,0);}
    if(target<new Date()){target.setMonth(target.getMonth()+1);}
    var p=function(n){return String(n).padStart(2,'0')};
    var tick=function(){
      var d=Math.max(0,target-new Date());
      var days=Math.floor(d/864e5);d-=days*864e5;
      var h=Math.floor(d/36e5);d-=h*36e5;
      var m=Math.floor(d/6e4);d-=m*6e4;
      var s=Math.floor(d/1e3);
      cd.querySelector('[data-d]').textContent=p(days);
      cd.querySelector('[data-h]').textContent=p(h);
      cd.querySelector('[data-m]').textContent=p(m);
      cd.querySelector('[data-s]').textContent=p(s);
    };
    tick();setInterval(tick,1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakaway-surf-club"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.bk-club-page'); if(!root||root.__bkcInit)return; root.__bkcInit=true;
  var els=root.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){io.observe(el);});
  } else { els.forEach(function(el){el.classList.add('in');}); }
  var cd=document.getElementById('bkc-count');
  if(cd){
    var draw=cd.getAttribute('data-draw'); var t=draw?new Date(draw+'T20:00:00'):null;
    if(!t||isNaN(t)){var n=new Date();t=new Date(n.getFullYear(),n.getMonth()+1,0,20,0,0);}
    if(t<new Date()){t.setMonth(t.getMonth()+1);}
    var p=function(n){return String(n).padStart(2,'0');};
    function tick(){var d=Math.max(0,t-new Date());var da=Math.floor(d/864e5);d-=da*864e5;var h=Math.floor(d/36e5);d-=h*36e5;var m=Math.floor(d/6e4);d-=m*6e4;var s=Math.floor(d/1e3);
      cd.querySelector('[data-d]').textContent=p(da);cd.querySelector('[data-h]').textContent=p(h);cd.querySelector('[data-m]').textContent=p(m);cd.querySelector('[data-s]').textContent=p(s);}
    tick();setInterval(tick,1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breakaway-surf-report"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initReport(root){
    if(root.dataset.bksrReady) return;
    root.dataset.bksrReady = "1";

    var q = function(sel){ return root.querySelector(sel); };
    var STORE_KEY = "bksr-spot";
    var CACHE_KEY = "bksr-cache";
    var CACHE_MS  = 10 * 60 * 1000; // 10 minutes
    var compass = function(deg){ return ["N","NE","E","SE","S","SW","W","NW"][Math.round(((deg%360)/45))%8]; };

    // "popular breaks" come from the theme blocks
    var presets = Array.prototype.map.call(root.querySelectorAll("[data-presets] span"), function(el){
      return { name:el.dataset.name, lat:parseFloat(el.dataset.lat), lon:parseFloat(el.dataset.lon) };
    });

    function saveSpot(spot){ try{ localStorage.setItem(STORE_KEY, JSON.stringify(spot)); }catch(e){} }
    function readSpot(){ try{ var v=localStorage.getItem(STORE_KEY); return v?JSON.parse(v):null; }catch(e){ return null; } }

    // ----- 10 minute cache, stored on the visitor's own device -----
    function cacheKey(spot){ return spot.lat.toFixed(3) + "," + spot.lon.toFixed(3); }
    function readCache(spot){
      try{
        var raw = localStorage.getItem(CACHE_KEY);
        if(!raw) return null;
        var c = JSON.parse(raw);
        if(!c || c.key !== cacheKey(spot)) return null;
        if(Date.now() - c.at > CACHE_MS) return null;
        return c;
      }catch(e){ return null; }
    }
    function writeCache(spot, data){
      try{
        localStorage.setItem(CACHE_KEY, JSON.stringify({ key:cacheKey(spot), at:Date.now(), data:data }));
      }catch(e){}
    }
    function localNowStr(){
      var d = new Date(), p = function(n){ return (n<10?"0":"") + n; };
      return d.getFullYear()+"-"+p(d.getMonth()+1)+"-"+p(d.getDate())+"T"+p(d.getHours())+":"+p(d.getMinutes());
    }

    var state = { spot: readSpot() || presets[0] || { name:"Redhead Beach", lat:-32.9987, lon:151.7173 } };

    function greeting(){
      var h = new Date().getHours();
      if (h < 12) return "Morning — surf's on";
      if (h < 17) return "Afternoon check";
      return "Evening glass-off";
    }
    function isNightAt(nowStr, sunriseStr, sunsetStr){
      if(!nowStr || !sunriseStr || !sunsetStr) return browserNight();
      return nowStr < sunriseStr || nowStr >= sunsetStr;
    }
    function browserNight(){ var h=new Date().getHours(); return h < 5 || h >= 19; }

    function verdict(waveH, windKmh, isNight){
      if (isNight){
        return waveH >= 1.2 ? "Big swell tonight — worth a dawn patrol"
                            : "Quiet out there — good night for a cold one 🍺";
      }
      if (windKmh > 28) return "Blown out — coffee weather ☕";
      if (waveH < 0.5)  return "Small & glassy — longboard day";
      if (waveH < 1.2)  return windKmh < 15 ? "Clean & fun 🤙" : "A bit of texture, still surfable";
      if (waveH <= 2)   return "Solid & fun — worth the paddle";
      return "Pumping — get out there";
    }
    function countUp(el, target, decimals){
      var dur=800, t0=performance.now();
      function step(t){
        var p=Math.min(1,(t-t0)/dur), eased=1-Math.pow(1-p,3);
        el.textContent=(target*eased).toFixed(decimals);
        if(p<1) requestAnimationFrame(step); else el.textContent=target.toFixed(decimals);
      }
      requestAnimationFrame(step);
    }
    function paint(spot, d, isLive, stamp){
      q("[data-greet]").textContent = greeting();
      q("[data-place]").textContent = spot.name + " · right now";
      countUp(q("[data-swell]"), d.waveH, 1);
      countUp(q("[data-wind]"),  d.windKmh, 0);
      countUp(q("[data-temp]"),  d.temp, 0);
      q("[data-swellnote]").textContent = d.wavePeriod ? d.wavePeriod.toFixed(0)+"s period · "+compass(d.waveDir) : " ";
      q("[data-windnote]").textContent  = compass(d.windDir) + " wind";
      q("[data-tempnote]").textContent  = d.temp >= 20 ? "boardies" : "spring suit";
      q("[data-verdict]").textContent   = verdict(d.waveH, d.windKmh, d.isNight);
      var dot=q("[data-dot]"), flag=q("[data-flag]");
      if(isLive){ dot.classList.remove("bksr-sample"); flag.textContent="Live"; }
      else { dot.classList.add("bksr-sample"); flag.textContent="Sample"; }
      q("[data-updated]").textContent = "Updated " + new Date(stamp || Date.now()).toLocaleTimeString("en-AU",{hour:"2-digit",minute:"2-digit"});
      root.classList.remove("bksr-loading");
    }

    var SAMPLE = { waveH:1.1, wavePeriod:9, waveDir:135, windKmh:12, windDir:225, temp:21 };
    function withTimeout(p, ms){ return Promise.race([p, new Promise(function(_,rej){ setTimeout(function(){ rej(new Error("timeout")); }, ms); })]); }

    function load(){
      var spot = state.spot;
      root.classList.add("bksr-loading");

      // fresh enough? use the copy on this device and skip the two API calls
      var cached = readCache(spot);
      if(cached){
        var c = cached.data;
        var cNight = (c.sunrise && c.sunset) ? isNightAt(localNowStr(), c.sunrise, c.sunset) : browserNight();
        paint(spot, {
          waveH:c.waveH, wavePeriod:c.wavePeriod, waveDir:c.waveDir,
          temp:c.temp, windKmh:c.windKmh, windDir:c.windDir, isNight:cNight
        }, true, cached.at);
        return;
      }

      var marineURL = "https://marine-api.open-meteo.com/v1/marine?latitude="+spot.lat+"&longitude="+spot.lon+"&current=wave_height,wave_period,wave_direction,sea_surface_temperature&timezone=auto";
      var windURL   = "https://api.open-meteo.com/v1/forecast?latitude="+spot.lat+"&longitude="+spot.lon+"&current=wind_speed_10m,wind_direction_10m&daily=sunrise,sunset&forecast_days=1&wind_speed_unit=kmh&timezone=auto";
      withTimeout(Promise.all([fetch(marineURL), fetch(windURL)]), 6000)
        .then(function(res){ return Promise.all([res[0].json(), res[1].json()]); })
        .then(function(j){
          var mc=j[0].current, wc=j[1].current, dl=j[1].daily || {};
          var night = (dl.sunrise && dl.sunset) ? isNightAt(wc.time, dl.sunrise[0], dl.sunset[0]) : browserNight();
          var data = {
            waveH:      mc.wave_height != null ? mc.wave_height : SAMPLE.waveH,
            wavePeriod: mc.wave_period != null ? mc.wave_period : SAMPLE.wavePeriod,
            waveDir:    mc.wave_direction != null ? mc.wave_direction : SAMPLE.waveDir,
            temp:       Math.round(mc.sea_surface_temperature != null ? mc.sea_surface_temperature : SAMPLE.temp),
            windKmh:    Math.round(wc.wind_speed_10m != null ? wc.wind_speed_10m : SAMPLE.windKmh),
            windDir:    wc.wind_direction_10m != null ? wc.wind_direction_10m : SAMPLE.windDir,
            sunrise:    dl.sunrise ? dl.sunrise[0] : null,
            sunset:     dl.sunset  ? dl.sunset[0]  : null
          };
          writeCache(spot, data);
          data.isNight = night;
          paint(spot, data, true);
        })
        .catch(function(){
          var s2 = { waveH:SAMPLE.waveH, wavePeriod:SAMPLE.wavePeriod, waveDir:SAMPLE.waveDir,
                     temp:SAMPLE.temp, windKmh:SAMPLE.windKmh, windDir:SAMPLE.windDir, isNight:browserNight() };
          paint(spot, s2, false);
        });
    }

    // ----- beach picker: popular breaks + Australia-wide search -----
    var toggleBtn = q("[data-picker-toggle]");
    var panel     = q("[data-search-panel]");
    var input     = q("[data-search-input]");
    var resultsEl = q("[data-results]");
    var nameEl    = q("[data-current-beach]");

    function setCurrentName(){ if(nameEl){ nameEl.textContent = state.spot.name; } }
    setCurrentName();

    function chooseSpot(spot){ state.spot = spot; saveSpot(spot); setCurrentName(); closePanel(); load(); }

    function renderList(items, hint){
      if(!resultsEl) return;
      resultsEl.innerHTML = "";
      if(hint){ var h=document.createElement("li"); h.className="bksr-hint"; h.textContent=hint; resultsEl.appendChild(h); }
      items.forEach(function(sp){
        var li=document.createElement("li");
        li.textContent = sp.name;
        if(sp.region){ var s=document.createElement("small"); s.textContent=sp.region; li.appendChild(s); }
        li.addEventListener("click", function(){ chooseSpot({ name:sp.name, lat:sp.lat, lon:sp.lon }); });
        // keyboard: reachable with Tab, chosen with Enter or Space
        li.tabIndex = 0;
        li.setAttribute("role", "button");
        li.addEventListener("keydown", function(e){
          if(e.key === "Enter" || e.key === " " || e.key === "Spacebar"){
            e.preventDefault();
            li.click();
          }
        });
        resultsEl.appendChild(li);
      });
    }

    function openPanel(){
      if(!panel) return;
      panel.hidden=false;
      if(toggleBtn) toggleBtn.setAttribute("aria-expanded","true");
      renderList(presets, "Popular breaks");
      if(input){ input.value=""; input.focus(); }
    }
    function closePanel(){
      if(!panel) return;
      panel.hidden=true;
      if(toggleBtn) toggleBtn.setAttribute("aria-expanded","false");
    }

    if(toggleBtn){
      toggleBtn.addEventListener("click", function(){
        (panel && panel.hidden) ? openPanel() : closePanel();
      });
    }

    // debounced search via Open-Meteo geocoding (free, keyless), Australia only
    var searchTimer=null;
    if(input){
      input.addEventListener("input", function(){
        var query=input.value.trim();
        clearTimeout(searchTimer);
        if(query.length < 2){ renderList(presets, "Popular breaks"); return; }
        renderList([], "Searching…");
        searchTimer=setTimeout(function(){
          var url="https://geocoding-api.open-meteo.com/v1/search?name="+encodeURIComponent(query)+"&count=8&language=en&format=json";
          fetch(url).then(function(r){ return r.json(); }).then(function(data){
            var list=(data.results||[]).filter(function(p){ return p.country_code==="AU"; }).map(function(p){
              return { name:p.name, lat:p.latitude, lon:p.longitude, region:[p.admin1,"Australia"].filter(Boolean).join(", ") };
            });
            if(list.length===0){ renderList([], "No Australian spots found"); }
            else { renderList(list, null); }
          }).catch(function(){ renderList([], "Search unavailable — pick a popular break"); });
        }, 300);
      });
    }

    load();
  }

  function initAll(){ document.querySelectorAll("[data-bksr]").forEach(initReport); }
  if(document.readyState !== "loading") initAll();
  else document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
